export const QaAnswerFrag = `
fragment QaAnswerFrag on QAContainerAnswer { 
  text {
    value
  }
  description {
    value
  }
  nextQuestion {
    id: targetId
  }
  service {
    id: targetId
  }
}
`;
